import { render } from "./EditorDetailsDrawer.vue?vue&type=template&id=4e5078f2&ts=true"
import script from "./EditorDetailsDrawer.vue?vue&type=script&lang=ts"
export * from "./EditorDetailsDrawer.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__